import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDzpNA_BkCPC1C6_bV9PwSqBSTEoPyo9XE",
  authDomain: "website-tracking-w-ai.firebaseapp.com",
  projectId: "website-tracking-w-ai",
  storageBucket: "website-tracking-w-ai.firebasestorage.app",
  messagingSenderId: "842709652430",
  appId: "1:842709652430:web:f002a3fecb01f663e5119f",
  measurementId: "G-C41E4XJ8YR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;